import { useAuth } from '../contextos/autenticacion/ContextoAutenticacion'

export const usePermisos = () => {
  const { usuario } = useAuth()

  const tienePermiso = (codigo: string): boolean => {
    if (!usuario) return false
    
    // Si el usuario es superadmin, tiene acceso total
    if (usuario.rol_global === 'superadmin') return true
    
    // Si el usuario tiene el rol 'admin', verificamos sus permisos específicos
    return usuario.permisos?.includes(codigo) || false
  }

  const tieneAlgunPermiso = (codigos: string[]): boolean => {
    if (!usuario) return false
    if (usuario.rol_global === 'superadmin') return true
    return codigos.some(codigo => usuario.permisos?.includes(codigo))
  }

  const tieneTodosPermisos = (codigos: string[]): boolean => {
    if (!usuario) return false
    if (usuario.rol_global === 'superadmin') return true
    return codigos.every(codigo => usuario.permisos?.includes(codigo))
  }

  return { tienePermiso, tieneAlgunPermiso, tieneTodosPermisos }
}
